import { render } from "./HeaderBack.vue?vue&type=template&id=53d7b393&scoped=true&ts=true"
import script from "./HeaderBack.vue?vue&type=script&lang=ts"
export * from "./HeaderBack.vue?vue&type=script&lang=ts"

import "./HeaderBack.vue?vue&type=style&index=0&id=53d7b393&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d7b393"]])

export default __exports__